import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { useFormik, FormikProvider } from 'formik';

import AppInput from 'shared/AppInput';
import AppToast from 'shared/AppToast';
import AsoExpressForm from './AsoExpressForm';
import GatewayLayout from './components/GatewayLayout';
import InstructionLine from './components/InstructionLine';

import axios from 'utils/axios-rails';

import { GatewayRegionAccountProvider } from '@hooks/GatewayRegionAccountContext';
import { GATEWAY_ID_TYPES_PROP } from 'utils/shape-props';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  checkoutId: PropTypes.string.isRequired,
  cancelURL: PropTypes.string.isRequired,

  displayAmount: PropTypes.string,
  regionAccountCountry: PropTypes.oneOf(['costa_rica', 'guatemala']).isRequired,

  idTypes: GATEWAY_ID_TYPES_PROP.isRequired,
}

const defaultProps = {
  displayAmount: null,
}

const AsoExpressGatewayForm = (props) => {
  const layoutRef = useRef(null);

  const handleSubmit = async (values) => {
    try {
      const response = await axios.post(props.submitURL, {
        aso_express: {
          // TODO MOVE THIS to BACKEND
          // On CR it is WIDELY common for people with Cedula Física to omit writing the 0 at the beginning, 
          // So it that's the case AUTO add it there, for other kinds ID should be send as written
          client_id: values.id_type === "ordinary" ? `0${values.client_id}` : values.client_id,
          ...values,
          checkout_id: props.checkoutId, // Required for some validations
        }
      });
      const { data } = response;
      if(data.success){
        layoutRef.current.setToastMessage(data.message);
        window.location.href = data.redirect_url; // Redirect to shopify with response params
      }
      else{
        console.log("Errors", data.errors);
        formik.setErrors(data.errors);
        layoutRef.current.setToastMessage(data.message);
      }
    } catch (error) {
      console.log("ErrorC", error)
      layoutRef.current.setToastMessage("Ocurrio un error de conexión con el servicio.");
    }
  }

  const formik = useFormik({ 
    initialValues: { 
      client_id: "", 
      // Default and not changeable for now (only one ID type supported for current integration). Should be the one for 'Cédula Fisica'
      id_type: props.idTypes[0].value,
      token: "",
    },
    onSubmit: handleSubmit,
  });

  const displayAmount = props.displayAmount || `₡${props.amount}`;

  return (
    <GatewayRegionAccountProvider regionAccountCountry={props.regionAccountCountry}>
      <GatewayLayout 
        ref={layoutRef}
        loading={formik.isSubmitting}
        cancelURL={props.cancelURL} 
        onSubmit={formik.handleSubmit}
        totalAmount={displayAmount}
      >
        <FormikProvider value={formik}>
          {/* Instructions */}
          <div className="mb32">
            <InstructionLine number={1}
              content={
                <p className="mb0">
                  <strong>Solicita un token de {displayAmount}</strong> en la web o app de tu Asociación o Cooperativa mediante AsoExpress.
                </p>
              }
            />
            <InstructionLine number={2}
              content={
                <p className="mb0">
                  <strong>Ingresa tu cédula y el token</strong> en los campos indicados. Debe ser exactamente {displayAmount}.
                </p>
              }
            />
            <InstructionLine number={3}
              content={
                <p className="mb0">
                  <strong>¡Listo!</strong> Tu pago se registrará automáticamente.
                </p>
              }
            />
          </div>

          <AsoExpressForm 
            idTypes={ props.idTypes }
          />
        </FormikProvider>
      </GatewayLayout>
    </GatewayRegionAccountProvider>
  )
};



AsoExpressGatewayForm.propTypes = propTypes;
AsoExpressGatewayForm.defaultProps = defaultProps;

export default AsoExpressGatewayForm;